
import { courseIncludes } from '../../../mocks/courseModules';

export default function IncludesSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 text-green-600 text-sm font-semibold rounded-full mb-4">
            <i className="ri-gift-line w-4 h-4 flex items-center justify-center"></i>
            Tudo Incluso
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            O que você recebe
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Muito mais do que um curso — é um kit completo para transformar sua prática pedagógica
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {courseIncludes.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-lg hover:border-orange-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center mb-4 group-hover:bg-orange-100 transition-colors">
                <i className={`${item.icon} text-orange-500 text-xl`}></i>
              </div>
              <p className="text-sm font-semibold text-gray-800 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
